let loading = false;
function forbidClick(e) {
  e.preventDefault();
}
function spin() {
  if (!loading) {
    loading = true;
    const wrapper = document.createElement('div');
    const img = document.createElement('img');
    img.setAttribute('src', '/static/images/mt-loading.gif');
    wrapper.classList.add('mt-loading');
    wrapper.appendChild(img);
    document.body.appendChild(wrapper);
    document.body.addEventListener('click', forbidClick, true);
  }
}
function stop() {
  loading = false;
  const loadingWrapper = document.getElementsByClassName('mt-loading')[0];
  if (loadingWrapper) {
    document.body.removeChild(loadingWrapper);
    document.body.removeEventListener('click', forbidClick, true);
  }
}
export default {
  spin,
  stop,
};
